import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import styles from "./style.module.scss";
import CreditOperatorForm from "@components/forms/CreditOperatorForm";

const CreditOperatorAddEdit = () => {
  const params = useParams()
  const { id: creditOperatorId } = params;

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      containerClassName={styles.mainContainer}
      title={`${!creditOperatorId ? 'Agregar' : 'Editar'} Operador de Tarjeta`}
      backUrl="/user/credit-operators"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "creditOperatorForm",
          type: "submit",
          color: "success"
        }
      ]}
    >
      <CreditOperatorForm
        formId="creditOperatorForm"
        id={creditOperatorId}
        saveRedirectUrl="/user/credit-operators"
      ></CreditOperatorForm>

    </PageContainer>
  );
}

export default CreditOperatorAddEdit;
